module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mentorship-connections"
  }, [(_vm.requestText) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.requestText = null
      }
    }
  }, [_c('div', {
    staticClass: "overlay-content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "close"
  }, [_c('i', {
    staticClass: "fa fa-times",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.requestText = null
      }
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Message from student")]), _vm._v(" "), _c('div', {
    staticClass: "text-content",
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.linkify(_vm.requestText))
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.requests) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.isMentor) ? _c('h2', [_vm._v("Mentee Connections Initiated")]) : _c('h2', [_vm._v("Mentor Connections Initiated")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), (_vm.isMentor) ? _c('th', [_vm._v("Student's Name")]) : _c('th', [_vm._v("Mentor's Name")]), _vm._v(" "), (_vm.isMentor) ? _c('th', [_vm._v("Student's Email")]) : _c('th', [_vm._v("Mentor's Email")]), _vm._v(" "), _c('th', [_vm._v("#1 Mentor's Approval")]), _vm._v(" "), _c('th', [_vm._v("#2 Student's Choice")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), (_vm.requests.length > 0) ? _c('tbody', _vm._l((_vm.requests), function(request) {
    return _c('tr', [(_vm.isMentor) ? _c('td', [_c('i', {
      staticClass: "fa fa-envelope-o",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openRequestText(request)
        }
      }
    }), _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": request.student.avatar
      }
    })]) : _c('td', [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": request.mentor.mentor_profile.avatar
      }
    })]), _vm._v(" "), (_vm.isMentor) ? _c('td', [_vm._v(_vm._s(request.student.firstName) + " " + _vm._s(request.student.lastName))]) : _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'mentorProfile',
          params: {
            id: request.mentor.id
          }
        }
      }
    }, [_vm._v("\n                                " + _vm._s(request.mentor.firstName) + " " + _vm._s(request.mentor.lastName) + "\n                            ")])], 1), _vm._v(" "), (_vm.isMentor) ? _c('td', [_c('a', {
      attrs: {
        "href": 'mailto:' + request.student.email
      }
    }, [_vm._v(_vm._s(request.student.email))])]) : _c('td', [_c('a', {
      attrs: {
        "href": 'mailto:' + request.mentor.email
      }
    }, [_vm._v(_vm._s(request.mentor.email))])]), _vm._v(" "), _c('td', [(_vm.isMentor && request.approvedByMentor === null) ? _c('span', {
      staticClass: "limbo"
    }, [_vm._v("\n                                Mentor Approved\n                                "), _c('i', {
      staticClass: "fa fa-check",
      on: {
        "click": function($event) {
          _vm.updateRequest(request.id, true)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-remove",
      on: {
        "click": function($event) {
          _vm.updateRequest(request.id, false)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (!_vm.isMentor && request.approvedByMentor === null) ? _c('span', {
      staticClass: "limbo disabled"
    }, [_vm._v("\n                                Mentor Approved\n                                "), _c('i', {
      staticClass: "fa fa-check"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-remove"
    })]) : _vm._e(), _vm._v(" "), (request.approvedByMentor === true) ? _c('span', {
      staticClass: "approved"
    }, [_vm._v("\n                                Mentor Approved\n                                "), _c('i', {
      staticClass: "fa fa-check"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-remove inactive"
    })]) : _vm._e(), _vm._v(" "), (request.approvedByMentor === false) ? _c('span', {
      staticClass: "declined"
    }, [_vm._v("\n                                Mentor Approved\n                                "), _c('i', {
      staticClass: "fa fa-check inactive"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-remove"
    })]) : _vm._e()]), _vm._v(" "), _c('td', [(!_vm.isMentor && request.approvedByStudent === null && request.approvedByMentor !== false) ? _c('span', {
      staticClass: "limbo"
    }, [_vm._v("\n                                Student Approved\n                                "), _c('i', {
      staticClass: "fa fa-check",
      on: {
        "click": function($event) {
          _vm.updateRequest(request.id, true)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-remove",
      on: {
        "click": function($event) {
          _vm.updateRequest(request.id, false)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.isMentor && request.approvedByStudent === null) ? _c('span', {
      staticClass: "limbo disabled"
    }, [_vm._v("\n                                Student Approved\n                                "), _c('i', {
      staticClass: "fa fa-check"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-remove"
    })]) : _vm._e(), _vm._v(" "), (request.approvedByStudent === true) ? _c('span', {
      staticClass: "approved"
    }, [_vm._v("\n                                Student Approved\n                                "), _c('i', {
      staticClass: "fa fa-check"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-remove inactive"
    })]) : _vm._e(), _vm._v(" "), (request.approvedByStudent === false) ? _c('span', {
      staticClass: "declined"
    }, [_vm._v("\n                                Student Approved\n                                "), _c('i', {
      staticClass: "fa fa-check inactive"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-remove"
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "status"
    }, [_vm._v("\n                            " + _vm._s(_vm.status(request)) + "\n                            "), ((_vm.localStorage.roles.includes('Student') || _vm.localStorage.roles.includes('CampusStudent')) &&
      (request.approvedByMentor !== true && request.approvedByMentor !== false) &&
      (_vm.status(request) === 'Waiting on them' || _vm.status(request) === 'Full')) ? _c('i', {
      staticClass: "fa fa-trash",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteRequest(request)
        }
      }
    }) : _vm._e()])])
  })) : _c('tbody', [_vm._m(0)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No connections made yet")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-630c051a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MentorConnections.vue
// module id = 2060
// module chunks = 2